type UrlSafe = string | number | boolean;

const valueToString = (value: UrlSafe): string =>
    encodeURIComponent(String(value ?? ''));

const objectToQueryString = (object: Record<string, UrlSafe | UrlSafe[]>) => {
    return Object.entries(object)
        .map(([key, value]) => {
            if (Array.isArray(value)) {
                return value
                    .map((valuePart) => `${key}[]=${valueToString(valuePart)}`)
                    .join('&');
            }

            return `${key}=${valueToString(value)}`;
        })
        .join('&');
};

export default objectToQueryString;
